import { render, staticRenderFns } from "./GoPagesRow.vue?vue&type=template&id=7a3a1d0e"
import script from "./GoPagesRow.vue?vue&type=script&lang=js"
export * from "./GoPagesRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports